import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

export const APP_TOOLTIP_ID = 'app-tooltip';

/**
 * Drop-in replacement for MUI Tooltip using react-tooltip.
 * Usage: <Tooltip title="Label" placement="top">{child}</Tooltip>
 */
function Tooltip({ title, placement = 'top', children, disabled }) {
	if (!children || title == null || title === '' || disabled) return children || null;

	const content = typeof title === 'string' || typeof title === 'number' ? String(title) : null;

	const injected = {
		'data-tooltip-id': APP_TOOLTIP_ID,
		'data-tooltip-place': placement,
	};
	if (content !== null) injected['data-tooltip-content'] = content;

	return React.cloneElement(children, {
		...children.props,
		...injected,
	});
}

/** Global tooltip host — render once near the app root. */
export function TooltipHost() {
	return (
		<ReactTooltip
			id={ APP_TOOLTIP_ID }
			style={ {
				fontSize: 11,
				padding: '3px 7px',
				borderRadius: 4,
				zIndex: 2000,
			} }
			opacity={ 1 }
			delayShow={ 100 }
		/>
	);
}

export default Tooltip;
